module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-Regular-6369ffaadc9213f2c272b8a611a6887f.woff";